// Google Tag Manager

  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PV8L5PK');

/*if (!isMobile.any) {
    var load_url = "https:\/\/portal2.comm100.io\/ShopifyApp\/Shopify\/CodePlan\/db96c0f4-f870-435a-a973-6c7d8221def9?shop=efavormart-home-decor.myshopify.com";
      var s = document.createElement('script');
          s.type = 'text/javascript';
          s.defer = true;
          s.src = load_url;
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
}*/